"use client";

import { c as _c } from "react/compiler-runtime";
import { useSequences } from "./context";
import { Row } from "./row";
interface ListProps {
  emptyHint?: string;
  /**
   * Parent-owned row click handler. When omitted, rows are display-only.
   */
  onPickRow?: (key: string) => void;
}

/**
 * Flat list of sequence rows, ordered by `delayMinutes` ascending. The
 * rendering order matches firing order — there is no manual reorder.
 */
export function List(t0) {
  const $ = _c(15);
  const {
    emptyHint,
    onPickRow
  } = t0;
  const {
    state: t1,
    meta: t2
  } = useSequences();
  const {
    drafts,
    editingKey
  } = t1;
  const {
    readOnly
  } = t2;
  if (drafts.length === 0) {
    const t3 = emptyHint ?? "No sequences yet";
    let t4;
    if ($[0] !== t3) {
      t4 = <div className="flex items-center justify-center rounded-md border border-dashed border-border-secondary px-3 py-4 text-caption text-foreground-muted">{t3}</div>;
      $[0] = t3;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    return t4;
  }
  let t3;
  let t4;
  if ($[2] !== drafts || $[3] !== editingKey || $[4] !== onPickRow || $[5] !== readOnly) {
    const sorted = [...drafts].sort(_temp);
    const interactive = !readOnly && !!onPickRow;
    t3 = "space-y-1.5";
    let t5;
    if ($[8] !== editingKey || $[9] !== interactive || $[10] !== onPickRow) {
      t5 = draft => <Row key={draft.key} draft={draft} selected={editingKey === draft.key} onClick={interactive ? () => onPickRow(draft.key) : undefined} />;
      $[8] = editingKey;
      $[9] = interactive;
      $[10] = onPickRow;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = sorted.map(t5);
    $[2] = drafts;
    $[3] = editingKey;
    $[4] = onPickRow;
    $[5] = readOnly;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp(a, b) {
  return a.delayMinutes - b.delayMinutes;
}